import fs from 'fs/promises'
import path from 'path'
import {v4 as uuidv4} from 'uuid'
import {type InboxItemModel, InboxItemSchema} from '../../domain'

/**
 * Filesystem-based repository for GTD Inbox Items
 */
export class InboxFileRepository {
    private baseDir: string
    private processedDir: string

    constructor() {
        this.baseDir = path.join(process.env.SWOFT_MONO_REPOS_ROOT || process.cwd(), 'gtd', 'inbox')
        this.processedDir = path.join(this.baseDir, 'processed')
    }

    async getInboxItems(): Promise<InboxItemModel[]> {
        await this.ensureDirs()
        const files = await fs.readdir(this.baseDir)
        const items: InboxItemModel[] = []
        for (const file of files) {
            if (!file.endsWith('.json')) continue
            const filePath = path.join(this.baseDir, file)
            try {
                const content = await fs.readFile(filePath, 'utf-8')
                const obj = JSON.parse(content)
                items.push(InboxItemSchema.parse(obj))
            } catch {
                continue
            }
        }
        return items
    }

    async createInboxItem(text: string, source?: string): Promise<InboxItemModel> {
        await this.ensureDirs()
        const now = new Date().toISOString()
        const id = uuidv4()
        const item = {id, text, source, processed: false, createdAt: now, updatedAt: now}
        const filePath = path.join(this.baseDir, `${id}.json`)
        await fs.writeFile(filePath, JSON.stringify(item, null, 2), 'utf-8')
        return InboxItemSchema.parse(item)
    }

    private async ensureDirs() {
        await fs.mkdir(this.baseDir, {recursive: true})
        await fs.mkdir(this.processedDir, {recursive: true})
    }
}
